// CategoryIdLayout.jsx
import React from 'react';
import { Outlet } from 'react-router';

import UniversalComponent from '../component/UniversalComponent.jsx';

const CategoryIdLayout = () => {
  return (
    <>
      <UniversalComponent
        filename="Container_MessageCategoryFeedsById"
        importer={
          /* #__LOADABLE__ */ () =>
            import('../container/MessageCategoryFeedsById.js')
        }
      >
        <Outlet />
      </UniversalComponent>
    </>
  );
};

export default CategoryIdLayout;
